import React, { ReactNode } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { brandingInfo } from "features/server/brandingSlice";
import { themes } from "theme/themes";

interface ButtonNewProps {
  type?: string;
  disabled?: boolean;
  text?: string;
  hasIcon?: boolean;
  icon?: ReactNode;
  onClick?: () => void;
  children?: React.ReactNode;
}

const ButtonNew: React.FC<ButtonNewProps> = ({
  type = "create",
  disabled = false,
  text = "Create",
  hasIcon = false,
  icon,
  onClick,
}) => {
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  const backgroundColor =
    type === "create"
      ? `${themeColors?.secondary}`
      : type === "outlineSecondary"
        ? "#fff"
        : type === "reject"
          ? "rgba(170, 9, 9, 0.1)"
          : type === "login"
            ? `${themeColors?.primary}`
            : type === "submit"
              ? `${themeColors?.secondary}`
              : type === "back"
                ? "#fff"
                : disabled
                  ? "#B8C0C6"
                  : "#fff";

  const textColor =
    type === "outlineSecondary"
      ? ""
      : type === "back"
        ? "text-black"
        : `text-white`;
  const border =
    type === "outlineSecondary"
      ? ""
      : type === "back"
        ? `border-1 border-solid border-black`
        : `border-none`;
  const varient =
    type === "outlineSecondary" || type === "back" ? "outlined" : "contained";

  const { t } = useTranslation();

  return (
    <Button
      variant={varient}
      onClick={onClick}
      className={`text-ellipsis overflow-hidden font-Saira font-[600] text-[14.5px] ${textColor} ${border} h-[38px] px-8 py-1 transition-none rounded-[7px]`}
      style={{
        background: backgroundColor,
        ...(type === "outlineSecondary"
          ? {
              color: themeColors?.secondary,
              border: `2px solid ${themeColors?.secondary}`,
            }
          : {}),
      }}
      disabled={disabled}
    >
      {hasIcon && icon}
      {t(text)}
    </Button>
  );
};

export default ButtonNew;
